import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observer } from "mobx-react";
import { mutationCreateAudienceImportJob, queryGetEmailCampaignAccount } from "Apollo";
import styled, { css } from 'styled-components'
import Button from "module-common/Button";
import { Config } from "constant";
import Tooltip from "module-common/Tooltip";
import IconRaw from "module-common/Icon";
import { ShowNotice } from "../../../Store";

const BYTES = {
    bytes: {
        base: 0,
        unit: 'bytes',
        format: function(bytes) { return `${bytes} ${this.unit}` }
    },
    kilobytes: {
        base: 1024,
        unit: 'kB',
        format: function(bytes) { return `${(bytes / this.base).toFixed(1)} ${this.unit}` }
    },
    megabytes: {
        base: 1024 * 1024,
        unit: 'mB',
        format: function(bytes) { return `${(bytes / this.base).toFixed(1)} ${this.unit}` }
    }
}

const bytesToHumanReadable = (bytes) => {
    if(bytes >= BYTES.bytes.base && bytes < BYTES.kilobytes.base) return BYTES.bytes.format(bytes)
    else if(bytes >= BYTES.kilobytes.base && bytes < BYTES.megabytes.base) return BYTES.kilobytes.format(bytes)
    else return BYTES.megabytes.format(bytes)
}


export default compose(
    graphql(mutationCreateAudienceImportJob, {
        name: 'createImportJob'
    }),
    graphql(queryGetEmailCampaignAccount, {
        name: 'account'
    })
)(
    observer(
        class ListView extends Component {  

            state = {
                uploadedFile: null,
                uploading: false
            }

            onFileUpload = event => {
                const file = event.target.files[0];
                const formData = new FormData();
                formData.append("file", file);
                this.setState(state => ({...state, uploading: true}))
                fetch(`${Config.apiUrl}/emailCampaign/uploadContact`, {
                  method: "POST",
                  headers: {
                    Accept: "application/json"
                  },
                  body: formData,
                  credentials: 'include'
                })
                .then(response => response.json())
                .then(list => {
                    this.setState(state => ({...state, uploadedFile: list[0], uploading: false}))
                })
                .catch(e => {
                    this.setState(state => ({...state, uploading: false}))
                })
              };

            onCreateImpotJob = async () => {
                const { createImportJob, audienceId, account: { getEmailCampaignAccount } = {} } = this.props
                const { uploadedFile } = this.state
                try {
                    const result = await createImportJob({
                        variables: {
                            audienceId: audienceId,
                            accountId: getEmailCampaignAccount.id,
                            fileName: uploadedFile.realFileName
                        }
                    })
                    console.log(result)
                    ShowNotice('upload-contact-success')
                } catch(e) {
                    console.log(e)
                    ShowNotice('upload-contact-error')
                } finally {
                    this.setState(state => ({...state, uploadedFile: null}))
                }
            }  

            render() {
                const { uploadedFile, uploading } = this.state
                return (
                    <UploadContactPanel>
                        <label htmlFor="upload-contact">
                            {!uploadedFile && <Button
                                color="blue"
                                size="large"
                                border
                                disabled={uploading}
                                onClick={() => {
                                    document.getElementById("upload-contact").click()
                                }}
                            >
                                {uploading ? 'Processing': 'Select File to Upload'}
                            </Button>}
                            {uploadedFile && (
                            <SpanSelection>
                                Upload {uploadedFile.fileName} ({bytesToHumanReadable(uploadedFile.size)}) ? 
                                <a onClick={(e) => {
                                    e.preventDefault()
                                    this.onCreateImpotJob()
                                }}> Yes </a> : <a onClick={(e) => {
                                    e.preventDefault()
                                    this.setState(state => ({...state, uploadedFile: null}))
                                }}> No </a>
                            </SpanSelection>)}
                        </label>
                        <HiddenFileInput
                            id="upload-contact"
                            onChange={this.onFileUpload}
                        />
                    </UploadContactPanel>
                );
            }
        }
    )
);

const UploadContactPanel = styled.div`
  height: 50px;
  padding-left: 10px;
`
const SpanSelection = styled.div`  
  align-self: center;    
`
  

const HiddenFileInput = styled.input.attrs({
    type: "file",
    accept: "application/*"
  })`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  `;



// WEBPACK FOOTER //
// ./src/module-email-campaign/audience/member/UploadContactWithMutation.js